import { createSelector } from 'reselect'

// selectors
import { subscriptionAvailablePlansSelector } from './'

export const subscriptionIsAvailablePlansLoadedSelector = createSelector(
  subscriptionAvailablePlansSelector,
  (availablePlans) => availablePlans && availablePlans.loaded,
)
